export default "__VITE_ASSET__e8ea9faa__"